import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import { Account } from '@mls-wallet/shared-types';

type AccountsData = {
  accounts: Account[];
};

const accountsFetcher = async (url: string): Promise<AccountsData> =>
  await denApi.get<AccountsData, void>(url);

// Hook for fetching all accounts
export function useAccounts(
  swrOptions?: SWRConfiguration<AccountsData>,
  enabled: boolean = true
) {
  const { data, error, isLoading, mutate } = useSWR<AccountsData>(
    enabled ? 'multichain-account' : null,
    accountsFetcher,
    { revalidateOnFocus: false, ...(swrOptions ?? {}) }
  );

  return {
    accounts: data?.accounts ?? [],
    isLoading,
    error,
    refresh: mutate,
  };
}
